/**
 * www.js – minimal bundle for website layout (www.spinshot.io)
 * Mirrors app vs www CSS split: app layout uses app.js, website uses www.js
 *
 * Includes: Bootstrap Collapse + Dropdown only (tree-shaken), Stimulus + www-only controllers
 * Excludes: Turbo (www uses full page nav), jQuery, chartkick, trix, ActionCable
 */
import Collapse from "bootstrap/js/src/collapse.js"
import Dropdown from "bootstrap/js/src/dropdown.js"
window.bootstrap = { Collapse, Dropdown }

import { Application } from "@hotwired/stimulus"
import SearchOverlayController from "./controllers/search_overlay_controller"
import NavbarActionsController from "./controllers/navbar_actions_controller"
import SpinshotNavController from "./controllers/spinshot_nav_controller"
import SpinshotFeaturesController from "./controllers/spinshot_features_controller"
import ParallaxController from "./controllers/parallax_controller"
import TechSpecsRevealController from "./controllers/tech_specs_reveal_controller"
import SeoSectionsController from "./controllers/seo_sections_controller"
import ScrollSnapKeyboardController from "./controllers/scroll_snap_keyboard_controller"
import ContactFormController from "./controllers/contact_form_controller"

window.Stimulus = Application.start()
Stimulus.register("search-overlay", SearchOverlayController)
Stimulus.register("navbar-actions", NavbarActionsController)
Stimulus.register("spinshot-nav", SpinshotNavController)
Stimulus.register("spinshot-features", SpinshotFeaturesController)
Stimulus.register("parallax", ParallaxController)
Stimulus.register("tech-specs-reveal", TechSpecsRevealController)
Stimulus.register("seo-sections", SeoSectionsController)
Stimulus.register("scroll-snap-keyboard", ScrollSnapKeyboardController)
Stimulus.register("contact-form", ContactFormController)
